<template>
  <div class="companyPerson">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadMoreList"
      >
      <div class="list-item-box" v-for="(lists,index) in list" :key="index" @click="$router.push('/travelAgency/personnelinfo?id=' + lists.id)">
        <div class="items-box">
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="poster-img" />
          <div class="info-box">
            <div class="name-box">
              <div class="username">{{lists.name}}</div>
              <div class="idenity" v-if="lists.idenity">{{lists.idenity}}</div>
            </div>
            <div class="companyname">{{lists.office}}</div>
          </div>
        </div>
         <rline  v-if="index < list.length - 1"></rline>
        </div>
      </van-list>
    </div>
</template>
<script>
    import api from '../../service/modules/travel'
    import rline from './components/line'
    export default {
        components: {
            rline
        },

        data () {
            return {
                list: [],
                pagination: { total: 0, current_page: 0, page_size: 10 },
                finished: false,
                loading: false,
                travelId: ''
            };
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getList();
            },
            getList () {
                api.getMemberList({ p: parseInt(this.pagination.current_page) + 1, travelId: this.travelId }).then(res => {
                    if (res.ret === 0) {
                        this.pagination = res.data.pagination;
                        let list = res.data.list
                        list.map(element => {
                            element.idenity = ''
                            if (element.type == 3) {
                                element.idenity = '出资人'
                                element.office = element.investedEnterpriseName
                            }
                            if (element.isSeriousPerson == 1) {
                                element.idenity = '紧急联络人'
                            }
                            if (element.type == 4) {
                                element.idenity = '计调人员'
                            }
                            return element
                        });
                        this.list = [...this.list, ...res.data.list];
                        if (this.list.length > 0) {
                            localStorage.travelMemberList = JSON.stringify(this.list)
                        }
                        this.loading = false;
                        if (
                            this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)
                        ) {
                            this.finished = true;
                        }
                    }
                })
            }
        },

        mounted () {
            this.travelId = this.$route.query.id
        },
        created () {}
    }
</script>
<style scoped lang="less">
.companyPerson {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);

    .list-item-box{
       box-sizing: border-box;
       padding: 0 12px;
       background: #fff;

    }

    .items-box {
      box-sizing: border-box;
      padding: 16px 0;
      display: flex;
      align-items: center;
      background: #fff;

      .poster-img {
        width: 36px;
        height: 36px;
        margin-right: 12px;
      }

      .info-box {
        .name-box {
          height: 16px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .username {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            margin-right: 8px;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
          }
          .idenity {
            background: rgba(255, 255, 255, 1);
            border-radius: 1px;
            border: 1px solid rgba(54, 179, 116, 1);
            box-sizing: border-box;
            padding: 0 4px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(54, 179, 116, 1);
            line-height: 14px;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
          }
        }
        .companyname {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
    }
}
</style>
